'use strict';

import angular from 'angular';
import filter from './filter.controller';

export default angular.module('bfastCaptureManagerApp.application.filter', [])
  .controller('AppFilterController', filter)
  .name;



// WEBPACK FOOTER //
// ./client/app/application/filter/index.js